import React from 'react';
import css from './index.css';

import {connect} from 'react-redux';
import {modalChange} from '~/modules/modal/actions';
import mapDispatch from '~/misc/mapDispatch';
import {saveLoadCityRatio, hideLoadCityRatio} from '~/modules/myLoads/actions';
import {track} from '~/misc/metrics';

const trackSave = () => {
  track('save and hide loads', {'save or hide': 1});
  track('save and hide loads', {'save loads': 1});
};

const trackHide = () => {
  track('save and hide loads', {'save or hide': 1});
  track('save and hide loads', {'hide loads': 1});
};

const SearchLoad = ({isSimilar, userIsLoggedIn, showLogIn, saveLoad, hideLoad, dialog}) => {
  const save = () => isSimilar ? saveLoad('similarLoads') : saveLoad('loads');
  const hide = () => isSimilar ? hideLoad('similarLoads') : hideLoad('loads');
  return (
    <div className={css.box}>
      {
        dialog && <div className={css.dialog}>
          <img src='/assets/right-green.svg' alt=''/>
          The loads you selected has been saved.
        </div>
      }
      <div className={css.wrapperButton}>
        <span className={css.button} onClick={userIsLoggedIn ? save : showLogIn}>
          <img src='/assets/ic-save.svg' alt=''/>
          Save
        </span>
        <span className={css.button} onClick={userIsLoggedIn ? hide : showLogIn}>
          <img src='/assets/ic-hide.svg' alt=''/>
          Hide
        </span>
      </div>
    </div>
  );
};

export default connect(({user: {isLoggedIn}, myLoads: {dialog}}) => ({
  userIsLoggedIn: isLoggedIn,
  dialog,
}), mapDispatch({
  showLogIn: () => modalChange('login', 'anonymous_banner'),
  saveLoad: (props, type) => {
    trackSave();
    return saveLoadCityRatio(type);
  },
  hideLoad: (props, type) => {
    trackHide();
    return hideLoadCityRatio(type);
  },
}))(SearchLoad);



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/compontents/RatioTable/searchLoad/index.js